import React, { Component } from "react";
import { Field } from "redux-form";
import { Row, Col } from "react-bootstrap";
import Typeahead from "../../../../components/common/typeahead/Typeahead";
import Select2 from "../../../../components/common/select/Select2";
import { required } from "../../../../utils/forms/validators";
import styles from "./AutoCompleteCity.scss";

class AutoCompleteCity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cities: {
        col: props.col || 6
      },
      defaultCitiesSelected: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedValue &&
      nextProps.selectedValue !== this.props.selectedValue &&
      typeof nextProps.selectedValue === "object"
    ) {
      const { description } = nextProps.selectedValue;
      this.props.onSearchCities(description);
    }
  }

  searchCities(query) {
    this.props.onSearchCities(query);
  }

  render() {
    const {
      focus,
      cities,
      commuteCities,
      id,
      isLoading,
      selectedValue
    } = this.props;

    return (
      <div data-standalone-searchbox="" className={styles.checkboxContainer}>
        <div>
          <Row className={styles.item}>
            <Col md={6} xs={12} className={styles.itemPadding}>
              <Field
                allowNew={false}
                component={Typeahead}
                focus={focus || false}
                focusOut={this.props.focusOut}
                icon={this.props.icon}
                isAsync={true}
                isLoading={isLoading || false}
                key={id}
                labelKey="description"
                minLength={3}
                name="city"
                placeholder="Your City & State"
                options={cities}
                selected={selectedValue ? [selectedValue] : null}
                validate={[required]}
                valueKey="id"
                onSearch={query => this.searchCities(query)}
              />
            </Col>
          </Row>
        </div>
        <div className={styles.divider} />
        <div>
          <div className={styles.sectionSubtitle}>
            Select your closest metro area (within 100 miles)
          </div>
          <Row className={styles.item}>
            <Col md={6} xs={12} className={styles.itemPadding}>
              <Field
                component={Select2}
                name="commute_city_id"
                options={commuteCities}
                placeholder="Closest Metro Area"
                type="select"
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default AutoCompleteCity;



// WEBPACK FOOTER //
// ./src/routes/candidate/completeProfile/components/AutoCompleteCity.js